import { render, staticRenderFns } from "./ContactOverview.vue?vue&type=template&id=8182beec&lang=pug&"
import script from "./ContactOverview.vue?vue&type=script&lang=js&"
export * from "./ContactOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports